<p-card class="mt-3 p-3">

    <div class="notes-header">
        <h3 class="notes-title">Internal notes</h3>
        <p-button label="+ Add note" severity="primary" size="small" (onClick)="addCarNoteDialog = true" />
    </div>

    @if (carNotesList().length === 0) {
    <div class="notes-empty">No notes yet</div>
    }

    <p-menu #noteMenu [model]="noteMenuItems" [popup]="true" />

    @for (note of carNotesList(); track note.id) {
    <div class="note-card">
        <div class="note-avatar" [style.background]="getAvatarColor(note.employeeName)">
            {{ getInitials(note.employeeName) }}
        </div>
        <div class="note-body">
            <div class="note-meta">
                <span class="note-author">{{ note.employeeName }}</span>
                <div class="note-meta-right">
                    <span class="note-date">{{ note.createdAt | date:'dd/MM/yyyy, hh:mm aa' }}</span>
                    <button class="note-menu-btn" (click)="openNoteMenu($event, note, noteMenu)">
                        <span>⋮</span>
                    </button>
                </div>
            </div>
            <span class="note-email">{{ note.employeeEmail }}</span>
            <p class="note-text">{{ note.note }}</p>
            <app-note-photos [photos]="note.photos" />
        </div>
    </div>
    }

    <div class="notes-footer">
        <span class="footer-count">Showing {{first + carNotesList().length}} of {{totalRecords()}}</span>
        <p-paginator [rows]="rows" [totalRecords]="totalRecords()" [first]="first"
            (onPageChange)="onPageChange($event)" [rowsPerPageOptions]="[20, 30, 50]" />
    </div>

    @defer (when addCarNoteDialog; prefetch on idle) {
    <app-add-car-note-form (addedCarNote)="onCarNoteAdded()" [selectedCarID]="carID"
        [(visibility)]="addCarNoteDialog" />
    }

    @defer (when updateCarNoteDialog; prefetch on idle) {
    <app-update-car-note-form (updatedCarNote)="onCarNoteUpdated()" [selectedCarNote]="selectedCarNote"
        [(visibility)]="updateCarNoteDialog" />
    }

    @defer (when deleteCarNoteDialog; prefetch on idle) {
    <app-delete-car-note-form (deletedCarNote)="onCarNoteDeleted()" [selectedCarNote]="selectedCarNote"
        [(visibility)]="deleteCarNoteDialog" />
    }
</p-card>